const UUID_KEY = 'user_uuid'

export function getOrCreateUUID(): string {
  let uuid = localStorage.getItem(UUID_KEY)
  if (!uuid) {
    uuid = crypto.randomUUID()
    localStorage.setItem(UUID_KEY, uuid)
  }
  return uuid
}
